export default __webpack_public_path__ + "static/NavigationSystem-84efa38a4b0b6e32c8d0688276f3a2f1.jpeg";